<script>
	import { fileContentChecker, isVideoFile } from "src/utils/misc";
	import VideoThumbnail from "../VideoPlayer/VideoThumbnail.svelte";

	export let thumbImg;
	export let altTag;
	export let id;
	export let selected;
	export let videoFrame = false;
</script>

<div class="thumbnail-cont" class:active={selected}>
	{#if isVideoFile(thumbImg) && videoFrame}
		<video
			class="sample cursor"
			src={`${thumbImg}#t=0.1`}
			preload="metadata"
			muted
			on:click
			on:keydown={() => {}}
		>
			<track kind="captions" label="Captions" />
		</video>
		<span class="play-badge">
			<svg viewBox="0 0 24 24" aria-hidden="true">
				<circle cx="12" cy="12" r="11" fill="rgba(0, 0, 0, 0.55)" />
				<path d="M9.5 7.5v9l7-4.5z" fill="#fff" />
			</svg>
		</span>
	{:else if isVideoFile(thumbImg)}
		<VideoThumbnail on:click />
	{:else}
		<img
			class="sample cursor"
			{id}
			src={fileContentChecker(thumbImg)}
			alt={altTag}
			on:click
			on:keydown={() => {}}
		/>
	{/if}
</div>

<style>
	/* Six columns side by side */
	.thumbnail-cont {
		position: relative;
		width: 8%;
		max-height: 100px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #ddd;
		margin: 22px 6px;
		border-radius: 4px;
		height: 62px;
	}

	/* Sized for the strip, which is shorter than the grid thumbnails. */
	.play-badge {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 20px;
		height: 20px;
		transform: translate(-50%, -50%);
		pointer-events: none;
	}

	/* Add a transparency effect for thumnbail images */
	.sample {
		opacity: 0.8;
	}

	.sample:hover {
		opacity: 1;
	}

	img,
	video {
		width: 100%;
		height: 100%;
		transition: all 0.1s ease-in-out;
		border-radius: 4px;
		object-fit: cover;
	}

	/* Add a pointer when hovering over the thumbnail images */
	.cursor {
		cursor: pointer;
	}

	.active {
		opacity: 1;
		border: 3px solid #d60c0c;
		box-sizing: border-box;
	}
</style>
